import { AlarmLevel } from './alarm-level';
import { MotorChannelType, MotorTypeStrings } from './channel-type';

export class MotorAlarmSetting {
    enable: boolean;
    motorType: MotorType;
    stopStatusString: string;
    stbyStatusString: string;
    runStatusString1: string;
    runStatusString2: string;
    runStatusString3: string;
    runStatusString4: string;
    runStatusString5: string;
    alarmGroupNo: number;
    reposeGroup1No: number;
    reposeGroup2No: number;
    delayTimer: number;
    alarmLevel: AlarmLevel;
}

export interface MotorSettingStrings {
    stopStatusString: string;
    stbyStatusString: string;
    runStatusString1: string;
    runStatusString2: string;
    runStatusString3: string;
    runStatusString4: string;
    runStatusString5: string;
}

export const MotorAlarmSettingFns = {
    create,
};

function create(isNull: boolean = false) {
    return {
        enable: isNull ? false : true,
        motorType: isNull ? MotorType.UNDEFINED : MotorType.RUN,
        stopStatusString: isNull ? '' : 'STOP',
        stbyStatusString: '',
        runStatusString1: isNull ? '' : 'RUN',
        runStatusString2: '',
        runStatusString3: '',
        runStatusString4: '',
        runStatusString5: '',
        alarmGroupNo: isNull ? 0 : 1,
        reposeGroup1No: 0,
        reposeGroup2No: 0,
        delayTimer: 0,
        alarmLevel: isNull ? AlarmLevel.None : AlarmLevel.Alarm,
    };
}
export enum MotorType {
    UNDEFINED = '',
    RUN = 'RUN',
    RUN_A = 'RUN-A',
    RUN_B = 'RUN-B',
    RUN_C = 'RUN-C',
    RUN_D = 'RUN-D',
    RUN_E = 'RUN-E',
    RUN_F = 'RUN-F',
    RUN_G = 'RUN-G',
    RUN_H = 'RUN-H',
    RUN_I = 'RUN-I',
    RUN_J = 'RUN-J',
    RUN_K = 'RUN-K',
}

type StatusStringField =
    | 'stopStatusString'
    | 'stbyStatusString'
    | 'runStatusString1'
    | 'runStatusString2'
    | 'runStatusString3'
    | 'runStatusString4';

export const motorRequiredStatusFields: Record<string, StatusStringField[]> = {
    [MotorTypeStrings[MotorChannelType.RUN]]: ['stopStatusString', 'runStatusString1'],
    [MotorTypeStrings[MotorChannelType.RUN_A]]: ['stopStatusString', 'stbyStatusString', 'runStatusString1'],
    [MotorTypeStrings[MotorChannelType.RUN_B]]: ['stopStatusString', 'runStatusString1', 'runStatusString2'],
    [MotorTypeStrings[MotorChannelType.RUN_C]]: ['stopStatusString', 'runStatusString1', 'runStatusString2'],
    [MotorTypeStrings[MotorChannelType.RUN_D]]: [
        'stopStatusString',
        'runStatusString1',
        'runStatusString2',
        'runStatusString3',
        'runStatusString4',
    ],
    [MotorTypeStrings[MotorChannelType.RUN_E]]: ['stopStatusString', 'runStatusString1', 'runStatusString2'],
    [MotorTypeStrings[MotorChannelType.RUN_F]]: [
        'stopStatusString',
        'runStatusString1',
        'runStatusString2',
        'runStatusString3',
        'runStatusString4',
    ],
    [MotorTypeStrings[MotorChannelType.RUN_G]]: ['stopStatusString', 'runStatusString1'],
    [MotorTypeStrings[MotorChannelType.RUN_H]]: ['stopStatusString', 'stbyStatusString', 'runStatusString1'],
    [MotorTypeStrings[MotorChannelType.RUN_I]]: ['stopStatusString', 'stbyStatusString', 'runStatusString1'],
    [MotorTypeStrings[MotorChannelType.RUN_J]]: [
        'stopStatusString',
        'stbyStatusString',
        'runStatusString1',
        'runStatusString2',
    ],
    [MotorTypeStrings[MotorChannelType.RUN_K]]: [
        'stopStatusString',
        'stbyStatusString',
        'runStatusString1',
        'runStatusString2',
    ],
};

export function getPrintStrings(motorSettings: MotorAlarmSetting): { status: string; signal: string }[] {
    if (!motorSettings) return;
    const motorType = motorSettings.motorType;
    if (motorType == MotorType.RUN) {
        return [
            { status: motorSettings.runStatusString1, signal: '88' },
            { status: motorSettings.stopStatusString, signal: '5' },
        ];
    } else if (motorType == MotorType.RUN_A) {
        return [
            { status: motorSettings.runStatusString1, signal: '88' },
            { status: motorSettings.stopStatusString, signal: '5' },
            { status: motorSettings.stbyStatusString, signal: '48' },
        ];
    } else if (motorType == MotorType.RUN_B) {
        return [
            { status: motorSettings.runStatusString2, signal: '88L' },
            { status: motorSettings.runStatusString1, signal: '88H' },
            { status: motorSettings.stopStatusString, signal: '5' },
        ];
    } else if (motorType == MotorType.RUN_C) {
        return [
            { status: motorSettings.runStatusString1, signal: '88S' },
            { status: motorSettings.runStatusString2, signal: '88E' },
            { status: motorSettings.stopStatusString, signal: '5' },
        ];
    } else if (motorType == MotorType.RUN_D) {
        return [
            { status: motorSettings.runStatusString2, signal: '88SL' },
            { status: motorSettings.runStatusString1, signal: '88SH' },
            { status: motorSettings.runStatusString4, signal: '88EL' },
            { status: motorSettings.runStatusString3, signal: '88EH' },
            { status: motorSettings.stopStatusString, signal: '5' },
        ];
    } else if (motorType == MotorType.RUN_E) {
        return [
            { status: motorSettings.runStatusString1, signal: '88F' },
            { status: motorSettings.runStatusString2, signal: '88R' },
            { status: motorSettings.stopStatusString, signal: '5' },
        ];
    } else if (motorType == MotorType.RUN_F) {
        return [
            { status: motorSettings.runStatusString2, signal: '88FL' },
            { status: motorSettings.runStatusString1, signal: '88FH' },
            { status: motorSettings.runStatusString4, signal: '88RL' },
            { status: motorSettings.runStatusString3, signal: '88RH' },
            { status: motorSettings.stopStatusString, signal: '5' },
        ];
    } else if (motorType == MotorType.RUN_G) {
        return [
            { status: motorSettings.runStatusString1, signal: 'AT' },
            { status: motorSettings.stopStatusString, signal: '5' },
        ];
    } else if (motorType == MotorType.RUN_H) {
        return [
            { status: motorSettings.runStatusString1, signal: '88' },
            { status: motorSettings.stopStatusString, signal: '5' },
            { status: motorSettings.runStatusString2, signal: 'AT' },
        ];
    } else if (motorType == MotorType.RUN_I) {
        return [
            { status: motorSettings.runStatusString1, signal: 'AT' },
            { status: motorSettings.stopStatusString, signal: '5' },
            { status: motorSettings.stbyStatusString, signal: '48' },
        ];
    } else if (motorType == MotorType.RUN_J) {
        return [
            { status: motorSettings.runStatusString2, signal: '88L' },
            { status: motorSettings.runStatusString1, signal: '88H' },
            { status: motorSettings.stopStatusString, signal: '5' },
            { status: motorSettings.stbyStatusString, signal: '48' },
        ];
    } else if (motorType == MotorType.RUN_K) {
        return [
            { status: motorSettings.runStatusString1, signal: '88E' },
            { status: motorSettings.runStatusString2, signal: '88B' },
            { status: motorSettings.stopStatusString, signal: '5' },
            { status: motorSettings.stbyStatusString, signal: '48' },
        ];
    }
}

export function getMotorChannelStrings(motorSettings: MotorAlarmSetting): string[] {
    const motorType = motorSettings.motorType;
    if (motorType == MotorType.RUN || motorType == MotorType.RUN_G) {
        return [motorSettings.runStatusString1, motorSettings.stopStatusString];
    } else if (motorType == MotorType.RUN_A || motorType == MotorType.RUN_I) {
        return [motorSettings.runStatusString1, motorSettings.stopStatusString, motorSettings.stbyStatusString];
    } else if (
        motorType == MotorType.RUN_B ||
        motorType == MotorType.RUN_C ||
        motorType == MotorType.RUN_H ||
        motorType == MotorType.RUN_E
    ) {
        return [motorSettings.runStatusString1, motorSettings.runStatusString2, motorSettings.stopStatusString];
    } else if (motorType == MotorType.RUN_D || motorType == MotorType.RUN_F) {
        return [
            motorSettings.runStatusString1,
            motorSettings.runStatusString2,
            motorSettings.runStatusString3,
            motorSettings.runStatusString4,
            motorSettings.stopStatusString,
        ];
    } else if (motorType == MotorType.RUN_J || motorType == MotorType.RUN_K) {
        return [
            motorSettings.runStatusString1,
            motorSettings.runStatusString2,
            motorSettings.stopStatusString,
            motorSettings.stbyStatusString,
        ];
    }
}

export const DEFAULT_STATUS_STRINGS: MotorSettingStrings = {
    stopStatusString: '',
    stbyStatusString: '',
    runStatusString1: '',
    runStatusString2: '',
    runStatusString3: '',
    runStatusString4: '',
    runStatusString5: '',
};

export const motorRunDefinitions: Record<MotorType, MotorSettingStrings> = {
    [MotorType.RUN]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        runStatusString1: 'RUN',
    },
    [MotorType.RUN_A]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        stbyStatusString: 'ST/BY',
        runStatusString1: 'RUN',
    },
    [MotorType.RUN_B]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        runStatusString1: 'RUN-H',
        runStatusString2: 'RUN-L',
    },
    [MotorType.RUN_C]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        runStatusString1: 'SUPPLY',
        runStatusString2: 'EXHAUST',
    },
    [MotorType.RUN_D]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        runStatusString1: 'SUPPLY-H',
        runStatusString2: 'SUPPLY-L',
        runStatusString3: 'EXHAUST-H',
        runStatusString4: 'EXHAUST-L',
    },
    [MotorType.RUN_E]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        runStatusString1: 'FORWARD',
        runStatusString2: 'REVERSE',
    },
    [MotorType.RUN_F]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        runStatusString1: 'FORWARD-H',
        runStatusString2: 'FORWARD-L',
        runStatusString3: 'REVERSE-H',
        runStatusString4: 'REVERSE-L',
    },
    [MotorType.RUN_G]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        runStatusString1: 'AUTO',
    },
    [MotorType.RUN_H]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        runStatusString1: 'RUN',
        runStatusString2: 'AUTO',
    },
    [MotorType.RUN_I]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        stbyStatusString: 'ST/BY',
        runStatusString1: 'AUTO',
    },
    [MotorType.RUN_J]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        stbyStatusString: 'ST/BY',
        runStatusString1: 'RUN-H',
        runStatusString2: 'RUN-L',
    },
    [MotorType.RUN_K]: {
        ...DEFAULT_STATUS_STRINGS,
        stopStatusString: 'STOP',
        stbyStatusString: 'ST/BY',
        runStatusString1: 'ECO-RUN',
        runStatusString2: 'BYPASS-RUN',
    },
    [MotorType.UNDEFINED]: {
        ...DEFAULT_STATUS_STRINGS,
    },
};

export function getMotorStatusStrings(type: MotorType): MotorSettingStrings {
    return motorRunDefinitions[type];
}
